module.exports = __webpack_public_path__ + "static/img/ent-27.8a277ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-27.jpg
// module id = tv/q
// module chunks = 51